














export default {
    name: "PerPage",
    props: {
        value: Number,
    },
    data() {
        return {
            selected: 10,
            options: [5, 10, 25, 50, 100, 500],
        };
    },
    watch: {
        selected: function () {
            this.$emit("input", this.selected);
        },
    },
};
